import { leaftechBrandColors } from "./brandColors";
import { wagoBrandColors } from "./brandColors";
import { enakonBrandColors } from "./brandColors";
import LeaftechLogoMain from "../../assets/images/LEAFTECH.svg";
import wagoLogoMain from "../../assets/images/WAGO.png";
import enakonLogoMain from "../../assets/images/ENAKON.png";

export const themes = {
  leaftech: {
    name: "leaftech",
    ...leaftechBrandColors,
    favicon: "/leaftech.svg",
    appName: "Leaftech 3D Viewer",
    fontFamily: "Nunito Sans",
    logo: {
      alt: "LeafTech",
      mainSrc: LeaftechLogoMain,
      height: 20,
    },
    links: {
      website: process.env.REACT_APP_LEAFTECH_WEBSITE_URL,
    },
  },
  wago: {
    name: "wago",
    ...wagoBrandColors,
    favicon: "/wagoW.png",
    appName: "Wago 3D Viewer",
    fontFamily: "WAGO Connective",
    logo: {
      alt: "Wago",
      mainSrc: wagoLogoMain,
      height: 32,
    },
    links: {
      website: process.env.REACT_APP_CLIENT_WEBSITE_URL,
    },
  },
  enakon: {
    name: "enakon",
    ...enakonBrandColors,
    favicon: "/enakonFavicon.png",
    appName: "Enakon 3D Viewer",
    fontFamily: "PT Sans",
    logo: {
      alt: "Enakon",
      mainSrc: enakonLogoMain,
      height: 48,
    },
    links: {
      website: process.env.REACT_APP_CLIENT_WEBSITE_URL,
    },
  },
};
